// Tracks completed Calendly bookings and opens Calendly links in the on-site
// popup widget so booking completion (calendly.event_scheduled) is observable.
// The OpenAI pixel event fires only on a completed booking — never on clicks.

import { trackEvent } from "./ga";

export const installCalendlyBookingTracking = () => {
  const onMessage = (event) => {
    if (event.origin !== "https://calendly.com") return;
    const data = event.data;
    if (!data || data.event !== "calendly.event_scheduled") return;

    const payload = data.payload || {};
    const bookingId = payload.invitee_uuid || payload.event_uri || "current-session-booking";
    const key = `calendly:appointment_scheduled:${bookingId}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");

    trackEvent("appointment_scheduled", { source_page: window.location.pathname });
  };

  const onClick = (e) => {
    const anchor = e.target.closest && e.target.closest('a[href^="https://calendly.com/"]');
    if (!anchor) return;
    if (!window.Calendly || typeof window.Calendly.initPopupWidget !== "function") return;
    e.preventDefault();
    window.Calendly.initPopupWidget({ url: anchor.href });
  };

  window.addEventListener("message", onMessage);
  document.addEventListener("click", onClick);
  return () => {
    window.removeEventListener("message", onMessage);
    document.removeEventListener("click", onClick);
  };
};
